import { jsx as _jsx } from "react/jsx-runtime";
import { EmptyState } from '@shopify/polaris';
/** Standard empty-state panel with heading, message, and CTA(s). */
export function EmptyStatePanel({ heading, children, primaryAction, secondaryAction, image = '', }) {
    return (_jsx(EmptyState, { heading: heading, image: image, ...(primaryAction
            ? { action: { content: primaryAction.content, onAction: primaryAction.onAction } }
            : {}), ...(secondaryAction
            ? {
                secondaryAction: {
                    content: secondaryAction.content,
                    url: secondaryAction.url,
                    external: secondaryAction.external ?? false,
                },
            }
            : {}), children: children }));
}
//# sourceMappingURL=EmptyStatePanel.js.map